import styled from 'styled-components/macro'
import ListItem from '@material-ui/core/ListItem'

const Wrapper = styled(ListItem)`
  padding: 0;
  display: flex;
  flex-flow: row wrap;
`

export default Wrapper
